
import React, { useRef, useEffect } from 'react';
import Navbar from './navbar';
import Hero from './herosection';

export default function HomePage() {

    return (
        <>
            <Navbar position="absolute" top={0} w="100%" />
            <Hero />
        </>
    );
}